export enum ReviewType {
  One2One,
  Batch,
}
